import iziToast from "izitoast";
import {LoadingActions} from "../Store/Loading/Slice";
import {Loading} from "../Models/LoadingType";
import {LType} from "../Store/Loading/Types";
import * as queryString from 'query-string';
import {RecoveryPasswordForm} from "../Components/Login/RecoveryPasswordModal";
import BaseModel from "../Models/BaseModel";
import moment from "moment";
import {
  COLUMN_PENDING,
  COLUMN_PICKUPS,
  COLUMN_SCHEDULED, COLUMN_TRANSIT
} from "../Components/Contants/DashboardContants";
import {Customer} from "../Models/Customer";
import {LoginBody} from "../Store/Auth/Types";
import {ModalActions} from "../Store/Modal/Slice";
import {Dispatch} from "react";
import {CONFIRM_MODAL} from "../Store/Modal/Types";
import {FormType} from "../Models/FormType";
import PickupTypes from "../Models/PickupTypes";
import Address from "../Models/Address";
import City from "../Models/City";
import {getShipmentWithKey} from "../Services";
import * as H from 'history';

export function toast(message: string, type: string = 'success'): void {
  if (!message) {
    return;
  }
  const toast: any = {
    message: message,
    position: 'topRight',
    displayMode: 2,
    closeOnClick: true
  };
  switch (type) {
    case 'error':
      iziToast.error(toast);
      break;
    case 'info':
      iziToast.info(toast);
      break;
    case 'warning':
      iziToast.warning(toast);
      break;
    default:
      iziToast.success(toast);
      break;
  }
}

export function setLoadingIdle(loading: LType) {
  return LoadingActions.change({
    loading,
    newStatus: { status: Loading.LoadingIdle}
  });
}

export function setLoadingPending(loading: LType) {
  return LoadingActions.change({
    loading,
    newStatus: { status: Loading.LoadingPending }
  });
}

export function setLoadingRejected(loading: LType, message?: string) {
  return LoadingActions.change({
    loading,
    newStatus: { status: Loading.LoadingRejected, message}
  });
}

export function setLoadingResolve(loading: LType, message?: string) {
  return LoadingActions.change({
    loading,
    newStatus: { status: Loading.LoadingResolved, message}
  });
}


export function hrefToObject() {
  const search = `?${window.location.href.split('?')[1]}`;
  return queryString.parse(search, { arrayFormat: 'comma' });
}

export function isEmpty(obj: any) {
  if (!obj) {
    return true;
  }
  return !Object.keys(obj).length;
}

export function isPresent(obj: any) {
  return !isEmpty(obj);
}


export const recoverPasswordFormValidation = (form:RecoveryPasswordForm, logged:boolean) => {
  if(isEmpty(form.password) && isEmpty(form.repeatPassword)) {
    return 'Los campos no pueden estar vacios';
  }

  if (isEmpty(form.password)) {
    return `Debe completar el campo ${logged ? 'contraseña actual' : 'nueva contraseña'} `;
  }

  if (isEmpty(form.repeatPassword)) {
    return `Debe completar el campo ${logged ? 'repetir' : ''} repetir nueva contraseña`;
  }

  if(form.password !== form.repeatPassword && !logged) {
    return 'Las contraseñas no coinciden';
  }
  return;
};

export const emailPattern = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

export const emailRegexPattern = /^(([^<>()\],;:\s@]+(\.[^<>()\],;:\s@]+)*)|(.+))@(([^<>()[\],;:\s@]+\.)+[^<>()[\],;:\s@]{2,})$/i;

export function getBaseModel<R extends BaseModel>(model: R) {
  return Object.keys(model).reduce((acc: any, key) : R => {
    let val = (model as any)[key] as any;
    if (val?.hasOwnProperty('_KEY')) {
      val = val._KEY;
    }
    if (key !== "_META") acc[key] = val;
    return acc;
  }, {});
}


export function Capitalize(input: string) {
  if (!input) return input;
  return input[0].toUpperCase() + input.substr(1).toLowerCase();
}

interface ComparatorOptions {
  asBoolean?: boolean;
  asDate?: boolean
}

export const comparator = (property: string = "name", options?: ComparatorOptions) => {
  if (options) {
    const {asBoolean, asDate} = options;
    if (asBoolean || asDate) return (a: any, b:any) => b[property] -  a[property];
  }
  return (a: any, b:any) => a[property].toString().localeCompare(b[property].toString());
};

export const toCopFormat = (input: number) => {
  return new Intl.NumberFormat(
    'es-CO',
    {style: 'currency', currency: 'COP'}
  ).format(input)
}

export function formatDDMMYYYHHmm(date: Date) {
  return moment(date).format("DD/MM/YYYY h:mm a");
}

export const getModelName = (obj?: {name: string, last_name?: string, [key: string]: any} | string) => {
  if (!obj || typeof obj === "string") {
    return "";
  }
  return `${obj.name}${addInitialSpace(obj.last_name)}`;
}

export const getAddress = (address: Address | string) => {
  if (!address || typeof address === 'string') {
    return "";
  }
  let city;
  const addr = `${address.address}${addInitialSpace(address.building)}${addInitialSpace(address.interior)}`;
  if (!(typeof address.city === "string")) {
    city = address.city as City;
  }
  if (city) {
    return addr.toLowerCase().includes(city.name.toLowerCase()) ? addr : `${city.name} - ${addr}`
  }
  return addr;
}

export const addInitialSpace = (word?: string) => word ? " " + word : "";

export const getColumnStyle = (name: string) => {
  if (name.toLocaleLowerCase() === COLUMN_PENDING.name.toLocaleLowerCase()) {
    return COLUMN_PENDING;
  } else if (name.toLocaleLowerCase() === COLUMN_SCHEDULED.name.toLocaleLowerCase()) {
    return COLUMN_SCHEDULED;
  } else if (name.toLocaleLowerCase() === COLUMN_PICKUPS.name.toLocaleLowerCase()) {
    return COLUMN_PICKUPS;
  } else {
    return COLUMN_TRANSIT;
  }
}


export const getCustomerValue = (company_selected:Customer, branch_selected:Customer) => {
  if (Boolean(branch_selected?._KEY)) {
    return branch_selected._KEY;
  }
  if(!Boolean(branch_selected?._KEY) && Boolean(company_selected?._KEY)){
    return company_selected?._KEY;
  }
  return '';
}


export const loginValidation = (loginForm:LoginBody) => {
  if(!Boolean(loginForm.login.length)) {
    return 'El campo correo electronico no puede estar vacio';
  }
  if(!Boolean(loginForm.password.length)) {
    return 'El campo contraseña no puede estár vacio';
  }
    return '';
};


const crypto = window.crypto as any || {
  getRandomValues: (array: Array<any>) => {
    for (let i = 0, l = array.length; i < l; i++) {
      array[i] = Math.floor(Math.random() * 256);
    }
    return array;
  }
};

export function uuidV4() {
  return ('' + 1e7 + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c: any) =>
    (((c ^ crypto.getRandomValues(new Uint8Array(1))[0]) & 15) >> (c / 4)).toString(16)
  );
}


export function openConfirmModal(dispatch: Dispatch<any>, question: string, cb: (confirmed?: boolean) => void) {
  dispatch(ModalActions.openModal({
    modal: CONFIRM_MODAL,
    data: {question},
    cb
  }));
}

export function getModalTitle(formType:string, modalName:string) {
  switch (formType) {
    case FormType.INSERT:
      return (`Crear ${modalName}`);
    case FormType.SHOW:
      return (`Detalle ${modalName}`);
    case FormType.UPDATE:
      return (`Editar ${modalName}`);
    default:
      return ;
  }
}


export const deepFinder = (obj: any, path: string) => {
  return path
    .split(".")
    .reduce((o, key) => o && o[key] ? o[key] : null, obj);
}

export const hasDots = (input: string) => input.includes(".");


export const regexNumber = /^\d+$/;


export const arrayToOptions = (array: Array<any>, valueKey: string, labelKey: string) => {
  return array.map(t => ({label: t[labelKey], value: t[valueKey]}));
}

export function formatDDMMYYY(date: Date) {
  return moment(date).format("DD/MM/YYYY");
}

export function formatHHmm(date: Date) {
  return moment(date).format("h:mm a");
}

export const equalsTime = (date: any, date2: any) => {
  if (date && date instanceof Date && date2 && date2 instanceof Date) {
    date.setSeconds(0);
    date.setSeconds(0);
    return date.getHours() === date2.getHours() &&
      date.getMinutes() === date2.getMinutes();
  }
  console.warn("'date' or 'date2' is not an instance of Date")
  return false;
}

export const timeGreaterThan = (date: any, date2: any) => {
  if (date && date instanceof Date && date2 && date2 instanceof Date) {
    date.setSeconds(0);
    date.setSeconds(0);
    const ms = moment(date).diff(moment(date2));
    return ms > 0;
  }
  console.warn("'date' or 'date2' is not an instance of Date")
  return -1;
}


export const timeLessThan = (date: any, date2: any) => {
  if (date && date instanceof Date && date2 && date2 instanceof Date) {
    date.setSeconds(0);
    date.setSeconds(0);
    const ms = moment(date).diff(moment(date2));
    return ms < 0;
  }
  console.warn("'date' or 'date2' is not an instance of Date")
  return -1;
}


export const getProgressLineStatus = (type:string) => {
  switch (type) {
    case PickupTypes.PENDIENTE:
      return 1115;
    case PickupTypes.AGENDADA:
      return 1115;
    case PickupTypes.RECOGIDA:
      return 1075;
    case PickupTypes.IN_ORIGIN_WAREHOUSE:
      return 948;
    case PickupTypes.TO_DISPATCH:
      return 825;
    case PickupTypes.IN_DESTINATION_WAREHOUSE:
      return 697;
    case PickupTypes.TO_HAULAGE:
      return 575;
    case PickupTypes.SHIPMENT_DELIVERED:
      return 200;
    default:
      return  1500;
  }
}

export const isDeleteVisible = (status:PickupTypes) => (
  (status === PickupTypes.PENDIENTE || status === PickupTypes.AGENDADA)
);

export const isEditVisible = (status:PickupTypes) => (
  (status === PickupTypes.PENDIENTE)
);

export const getShipment = async (consecutive?: string | number) => {
  if (consecutive) {
    const res = await getShipmentWithKey({consecutive});
    if (res.success && res.shipment) {
      return res.shipment;
    } else {
      toast('Guia no encontrada', 'error');
    }
  } else {
    toast('Debes escribir un numero de guia', 'warning');
  }
  return {};
}

export const onSearchShipment = async (history: H.History, consecutive?: string | number) => {
  const {_KEY: key} = await getShipment(consecutive);
  if (key) {
    history.push({
      pathname: '/shipment',
      search: queryString.stringify({key})
    });
  }
}

export const getFirstDayOfCurrentMonth = () => {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0);
}

export const getTodayWithTime = (hours: number, minutes: number, seconds: number) => {
  const today = new Date();
  today.setHours(hours, minutes, seconds);
  return today;
}

export const getLastFiveYear = () => {
  const today = new Date();
  const years = [];
  for (let index = 0; index < 5; index++) {
    const year = new Date();
    year.setFullYear(today.getFullYear() - index)
    years.push(year);
  }
  return years.filter(year => year.getFullYear() > 2019);
}

export const getMonths = () => {
  return ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
}
